// extracted by mini-css-extract-plugin
export default {"pin":"style_pin__uvFzU","planet":"style_planet__Qg5lx","outer":"style_outer__Kkfel","map":"style_map__op4tm"};